<template>
  <div
    :class="bem()"
  >
    <Swiper
      :class="bem('list')"
      :slides-per-view="1"
      :autoplay="{
        disableOnInteraction: false,
        delay: 5000,
      }"
      :grab-cursor="true"
      :loop="true"
      :modules="modules"
      @touch-start="handleTouchStart"
      @touch-end="handleTouchEnd"
    >
      <SwiperSlide
        v-for="dynamicBanner in dynamicBanners"
        :key="dynamicBanner.id"
        :class="bem('list-item')"
      >
        <FilterBannerGeneric :item="dynamicBanner" />
      </SwiperSlide>
      <SwiperSlide
        v-for="bannerItem in hardcodedBanners"
        :key="bannerItem.id"
        :class="bem('list-item')"
      >
        <FilterBannerRepair v-if="bannerItem.bannerStyle === 'lifetime-guarantee'" />
        <FilterBannerCarbonNeutral
          v-else-if="bannerItem.bannerStyle === 'carbon-neutral'"
        />
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay } from 'swiper/modules'
import 'swiper/css/autoplay'

const props = defineProps({
  banners: {
    type: Array,
    default: () => [],
  },
})

const modules = [Autoplay]

function handleTouchStart(swiper) {
  swiper.autoplay.pause()
}

function handleTouchEnd(swiper) {
  swiper.autoplay.resume()
}

const dynamicBanners = computed(() => {
  return props.banners
    .filter((bannerItem) => bannerItem.bannerStyle === 'custom')
})

const hardcodedBanners = computed(() => {
  return props.banners
    .filter((bannerItem) => bannerItem.bannerStyle !== 'custom')
})

const bem = useBEM('FilterBannerGallery')
</script>

<style lang="postcss">
.FilterBannerGallery {
  @apply relative;
}

.FilterBannerGallery,
.FilterBannerGallery__list,
.FilterBannerGallery__list-item {
  @apply flex basis-full grow shrink-0 w-full;
}

.FilterBannerGallery__list-item {
  @media (max-width: 352px) {
    min-height: 360px;
  }
}
</style>
